import React, { useCallback, useEffect, useState } from 'react'
import styles from './login.module.css'
import { useNavigate } from 'react-router-dom'
import { useFormik } from "formik"
import * as yup from "yup";
import { Box, Checkbox, CircularProgress, TextField } from '@mui/material';
import { ArrowIcon, GoogleIcon, HidePasswordIcon, LogoIcon, PasswordVisible } from '../../../svg';
import CustomizedCheckbox from '../../../component/CustomizedCheckbox';
import { useDispatch } from 'react-redux';
import { registerStudent, registerWithGoogle } from '../../redux/registerStudentSlice';
import {
    signInWithPopup,
    GoogleAuthProvider,
} from "firebase/auth";
import { auth } from '../../helper/firebase';
import { unwrapResult } from '@reduxjs/toolkit';
import RegistrationModal from '../../../component/RegistrationModal';
import Toastify from '../../helper/Toastify';
import ReCAPTCHA from "react-google-recaptcha";
import Select from "react-select"
import { state } from '../../helper/data';


const Registration = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [googleErrorMessage, setGoogleErrorMessage] = useState("");
    const [error, setError] = useState(false);
    const [showModal, setShowModal] = useState(false)
    const [checked, setChecked] = useState(false);
    const [captchaValue, setCaptchaValue] = useState(null);


    // schema -----------
    const schema = yup.object().shape({
        email: yup.string().matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, "Please enter valid email").required("Please enter valid email"),
        password: yup.string().required("Password is required"),
        name: yup.string().required("Name is required"),
        city: yup.string().required("City is required"),
        state: yup.string().required("State is required"),
        locality: yup.string().required("Locality is required"),
        pincode: yup.string().matches(/^\d{6}$/, "Pincode must be 6 digit long").required("pincode is required"),
        phone: yup.string().matches(/^\d{10}$/, 'Phone must be 10 digits').required("Phone is required"),
        confirmPassword: yup.string().required("Confirm Password is required"),
    })

    const {
        errors, values, handleChange, touched, setFieldValue, handleBlur, resetForm, handleSubmit,
    } = useFormik({
        initialValues: {
            email: "",
            password: "",
            name: "",
            phone: "",
            confirmPassword: "",
            city: "",
            state: "",
            pincode: "",
            locality: ""
        },
        validationSchema: schema,
        onSubmit: (values) => {

            if (!captchaValue) {
                Toastify.error("Please verify the reCAPTCHA")
                return;
            }

            handleLogin(values);
        }
    })

    const handleLogin = async (values) => {
        if (!checked) {
            return Toastify.error("Accept terms and conditions")
        }
        setLoading(true);
        try {
            const result = await dispatch(registerStudent(values));
            unwrapResult(result)
            // navigate('/courses/Courses');
            openModal()

        } catch (error) {
            console.error('Login failed:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleCaptchaChange = (value) => {
        setCaptchaValue(value);
    };


    const handleGoogleSignUp = async (e) => {

        e.preventDefault();

        // Instantiate a GoogleAuthProvider object
        const provider = new GoogleAuthProvider();

        try {
            // Sign in with a pop-up window
            const result = await signInWithPopup(auth, provider);

            // Pull signed-in user credential.
            const user = result.user;

            console.log("sasaas", result)

            const resultAction = await dispatch(registerWithGoogle({
                email: user.email,
                googleIdToken: user.accessToken
            }));

            unwrapResult(resultAction);

            navigate("/courses/Courses")

        } catch (err) {
            // Handle errors here.
            const errorMessage = err.message;
            const errorCode = err.code;

            setError(true);

            switch (errorCode) {
                case "auth/operation-not-allowed":
                    setGoogleErrorMessage("Email/password accounts are not enabled.");
                    break;
                case "auth/operation-not-supported-in-this-environment":
                    setGoogleErrorMessage("HTTP protocol is not supported. Please use HTTPS.")
                    break;
                case "auth/popup-blocked":
                    setGoogleErrorMessage("Popup has been blocked by the browser. Please allow popups for this website.")
                    break;
                case "auth/popup-closed-by-user":
                    setGoogleErrorMessage("Popup has been closed by the user before finalizing the operation. Please try again.")
                    break;
                default:
                    setGoogleErrorMessage(errorMessage);
                    break;
            }
        }
    };

    const openModal = () => {
        setShowModal(true)
    }


    const maskEmail = (email) => {
        if (!email || typeof email !== 'string') {
            return ""; // Return an empty string or a default masked email if the input is invalid
        }
        const [username, domain] = email?.split("@"); // Split into username and domain
        if (username.length <= 2) {
            // If the username is too short, keep only the first character and mask the rest
            return `${username[0]}***@${domain}`;
        }
        // Otherwise, keep the first two characters and mask the rest
        return `${username.substring(0, 2)}***@${domain}`;
    };

    const handleCheckBoxChange = (e) => {
        setChecked(e.target.checked)
    }




    return (
        <div className={styles.main}>
            <div className={styles.mainContainer}>
                <div style={{ cursor: "pointer" }} onClick={() => navigate("/")}>
                    <LogoIcon />
                </div>
            </div>
            <div className={styles.login}>
                <div className={styles.mobileViewLogin}>
                    <div className={styles.mobileLogoStyle}>
                        <h3>KINGSTER</h3>
                    </div>
                </div>
                <div className={styles.content} style={{ marginTop: 30 }}>
                    <h3>Create your account</h3>
                    {/* <p>Please login to continue to your account.</p> */}
                    <form autoComplete='off'>
                        <div style={{ marginTop: 30 }}>
                            <label className={styles.label}>Full Name</label>
                            <div className={styles.inputbox}>
                                <input type='text' onBlur={handleBlur} value={values.name}
                                    // placeholder='Full Name'
                                    name="name" onChange={handleChange} autocomplete="off" />

                            </div>
                            {
                                errors.name && touched.name && <p style={{ color: "red", fontSize: "12px", textAlign: "left" }}>{errors.name}</p>
                            }

                        </div>
                        <div className={styles.inputboxStyle}>
                            <div className={styles.inputMobileResponsive}>
                                <label className={styles.label}>Email</label>
                                <div className={styles.inputBox}>
                                    <input
                                        type='email'
                                        onBlur={handleBlur}
                                        value={values.email}
                                        // placeholder='Email Address'
                                        name="email"
                                        onChange={handleChange}
                                        autocomplete="off"
                                    />
                                </div>
                                {
                                    errors.email && touched.email && <p style={{ color: "red", fontSize: "12px", textAlign: "left" }}>{errors.email}</p>
                                }
                            </div>
                            <div className={styles.inputMobileResponsive}>
                                <label className={styles.label}>Phone Number</label>
                                <div className={styles.inputBox}>
                                    <input type='number' onBlur={handleBlur} value={values.phone}
                                        // placeholder='Phone Number'
                                        name="phone" onChange={handleChange} autocomplete="off" />
                                </div>
                                {
                                    errors.phone && touched.phone && <p style={{ color: "red", fontSize: "12px", textAlign: "left" }}>{errors.phone}</p>
                                }
                            </div>
                        </div>
                        <div className={styles.inputboxStyle}>
                            <div className={styles.inputMobileResponsive}>
                                <label className={styles.label}>State</label>
                                <div className={styles.inputBox} style={{ padding: 0 }}>
                                    {/* <input
                                        type='text'
                                        onBlur={handleBlur}
                                        value={values.state}
                                        name="state"
                                        onChange={handleChange}
                                        autocomplete="off"
                                    /> */}

                                    <Select
                                        options={[{
                                            options: Object.keys(state)?.map((state) => {
                                                return {
                                                    value: state,
                                                    label: state,
                                                }
                                            })
                                        }]}
                                        value={{
                                            value: values.state,
                                            label: values?.state,
                                        }}
                                        name='state'
                                        // components={{ Option, GroupHeading }}
                                        styles={{ container: (styles) => ({ ...styles, width: "100%" }), singleValue: (styles) => ({ ...styles, fontSize: "13px", paddingLeft: "12px" }), control: (styles) => ({ ...styles, padding: "3px 0", border: "none", borderColor: "transparent !important", boxShadow: "none" }) }}
                                        onChange={(value) => handleChange({
                                            target: {
                                                value: value.value,
                                                name: "state"
                                            }
                                        })}
                                    />
                                </div>
                                {
                                    errors.state && touched.state && <p style={{ color: "red", fontSize: "12px", textAlign: "left" }}>{errors.state}</p>
                                }
                            </div>
                            <div className={styles.inputMobileResponsive}>
                                <label className={styles.label}>City</label>
                                <div className={styles.inputBox}>
                                    <input type='text' onBlur={handleBlur} value={values.city}
                                        // placeholder='Phone Number'
                                        name="city" onChange={handleChange} autocomplete="off" />
                                </div>
                                {
                                    errors.city && touched.city && <p style={{ color: "red", fontSize: "12px", textAlign: "left" }}>{errors.city}</p>
                                }
                            </div>
                        </div>
                        <div className={styles.inputboxStyle}>
                            <div className={styles.inputMobileResponsive}>
                                <label className={styles.label}>Home address</label>
                                <div className={styles.inputBox}>
                                    <input
                                        type='text'
                                        onBlur={handleBlur}
                                        value={values.locality}
                                        name="locality"
                                        onChange={handleChange}
                                        autocomplete="off"
                                    />
                                </div>
                                {
                                    errors.locality && touched.locality && <p style={{ color: "red", fontSize: "12px", textAlign: "left" }}>{errors.locality}</p>
                                }
                            </div>
                            <div className={styles.inputMobileResponsive}>
                                <label className={styles.label}>Pincode</label>
                                <div className={styles.inputBox}>
                                    <input type='text' onBlur={handleBlur} value={values.pincode}
                                        // placeholder='Phone Number'
                                        name="pincode" onChange={handleChange} autocomplete="off" />
                                </div>
                                {
                                    errors.pincode && touched.pincode && <p style={{ color: "red", fontSize: "12px", textAlign: "left" }}>{errors.pincode}</p>
                                }
                            </div>
                        </div>
                        <div className={styles.inputboxStyle}>
                            <div className={styles.inputMobileResponsive} >
                                <label className={styles.label}>Password</label>
                                <div className={styles.inputBox}>
                                    <input
                                        type={showNewPassword ? 'text' : 'password'}
                                        onBlur={handleBlur}
                                        value={values.password}
                                        // placeholder='Password'
                                        name="password"
                                        onChange={handleChange}
                                        autocomplete="new-password"
                                    />
                                    <div onClick={() => setShowNewPassword(!showNewPassword)} style={{ display: 'flex', alignItems: 'center', justifyContent: "center" }}>
                                        {showNewPassword ? <PasswordVisible /> : <HidePasswordIcon />}
                                    </div>
                                </div>
                                {
                                    errors.password && touched.password && <p style={{ color: "red", fontSize: "12px", textAlign: "left" }}>{errors.password}</p>
                                }
                            </div>
                            <div className={styles.inputMobileResponsive} >
                                <label className={styles.label}>Confirm Password</label>
                                <div className={styles.inputBox}>
                                    <input
                                        type={showNewPassword ? 'text' : 'password'}
                                        onBlur={handleBlur}
                                        value={values.confirmPassword}
                                        // placeholder='Confirm Password'
                                        name="confirmPassword"
                                        onChange={handleChange}
                                        autocomplete="new-password"
                                    />
                                    <div onClick={() => setShowNewPassword(!showNewPassword)}>
                                        {showNewPassword ? <PasswordVisible /> : <HidePasswordIcon />}
                                    </div>
                                </div>
                                {
                                    errors.confirmPassword && touched.confirmPassword && <p style={{ color: "red", fontSize: "12px", textAlign: "left" }}>{errors.confirmPassword}</p>
                                }
                            </div>

                        </div>
                        <div style={{ transform: "scale(0.7)", transformOrigin: "0 0", marginTop: "10px" }}>
                            <ReCAPTCHA
                                sitekey="6Lc8vBcrAAAAANcniDVhDJlYjI_dim7gFk3L4u19"
                                onChange={handleCaptchaChange}
                                style={{ height: "40px" }}
                            />
                        </div>
                    </form>
                    <div className={styles.checkStyle} style={{ marginTop: 20 }}>
                        <div style={{ marginLeft: -10, display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <Checkbox
                                checked={checked}
                                onChange={handleCheckBoxChange}
                                inputProps={{ 'aria-label': 'controlled' }}
                            />
                            <div>
                                <span className={styles.agreeText}>I Agree with all of your <span style={{ color: '#564FFD' }}>Terms & Conditions</span> </span>
                            </div>
                        </div>
                        <div className={styles.saveButtonStyle} onClick={handleSubmit} disabled={loading}>
                            {
                                loading ?
                                    <CircularProgress size={25} thickness={4.5} sx={{ color: "#fff" }} />
                                    : "Create Account "
                            } <ArrowIcon />
                        </div>
                    </div>
                    <div style={{ marginTop: 20 }}>
                        <div onClick={handleGoogleSignUp}>
                            <div className={styles.signWith} style={{ marginTop: 20 }}>
                                <div className={styles.lineStyle} />
                                <div className={styles.orText}>
                                    SIGN UP WITH
                                </div>
                                <div className={styles.lineStyle} />
                            </div>
                            <div className={styles.google}>
                                <div className={styles.googleStyle}>
                                    <GoogleIcon /> <div className={styles.singleLine} />Google
                                </div>
                            </div>
                        </div>
                        <div className={styles.textStyle}>
                            Already at Kingster? <span className={styles.loginText} onClick={() => navigate('/login')}>Login</span>
                        </div>
                    </div>

                </div>
            </div>

            <RegistrationModal
                open={showModal}
                // open={true}
                desc={`We have sent you an OTP to your  ${maskEmail(values?.email)}, please check and verify.`}
                data={values}
                closeModal={() => setShowModal(false)}

            />
        </div>
    )
}



export default Registration;
